import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import * as React from "react";
import CredentialPoints from "./CredentialPoints/CredentialPoints";
import "./Credentials.css";
import { CredentialTier } from "./CredentialTier/CredentialTier";
import { useGetBadgesQuery } from "../../../../redux-toolkit/features/my-activity/myActivityApiSlice";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const Credentials = () => {
  const [value, setValue] = React.useState(0);

  const { data } = useGetBadgesQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <div className="container">
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Points"
              sx={{
                textTransform: "capitalize",
                marginRight: "20px",
                fontWeight: "500",
              }}
              {...a11yProps(0)}
            />
            <Tab
              sx={{ textTransform: "capitalize", fontWeight: "500" }}
              label="Tasks"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <CredentialPoints points={data?.data?.filter((badge)=>badge._id.badgeType=="POINT")[0].badges} />
        </TabPanel>
        {data?.data && (<TabPanel value={value} index={1}>
          <div className="credentials__CredentialTier">
            {data?.data?.filter((badge)=>badge._id.badgeType=="TASK").map((tier, i) => {
              return <CredentialTier key={i} tier={tier.badges} />;
            })}
          </div>
        </TabPanel>)}
      </Box>
    </div>
  );
};
